export default __webpack_public_path__ + "static/media/contact-icons.57c6ecad.png";